import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import LoginPage from './pages/LoginPage';
import SignUpPage from './pages/SignUpPage';
import DashboardPage from './pages/DashboardPage';
import SessionPage from './pages/SessionPage';
import PairDevicePage from './pages/PairDevicePage';
import BillingPage from './pages/BillingPage';
import { OAuthCallback } from './components/auth/OAuthCallback';

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={user ? <Navigate to="/dashboard" /> : <LoginPage />} />
      <Route path="/signup" element={user ? <Navigate to="/dashboard" /> : <SignUpPage />} />
      <Route path="/auth/callback" element={<OAuthCallback />} />

      {/* Protected routes */}
      <Route
        path="/dashboard"
        element={user ? <DashboardPage /> : <Navigate to="/login" />}
      />
      <Route
        path="/session/:sessionId"
        element={user ? <SessionPage /> : <Navigate to="/login" />}
      />
      <Route
        path="/pair"
        element={user ? <PairDevicePage /> : <Navigate to="/login" />}
      />
      <Route
        path="/billing"
        element={user ? <BillingPage /> : <Navigate to="/login" />}
      />

      {/* Default redirect */}
      <Route path="/" element={<Navigate to={user ? "/dashboard" : "/login"} />} />
    </Routes>
  );
}

export default App;
